(function () {
  if (window.ParityConvermaxMakeOrder) return;

  var priorityMakes = [
    ['harley davidson', 'harley davidsion'],
    ['indian', 'indian motorcycle'],
    ['polaris', 'polaris industries'],
  ];
  var vehicleFields = ['Year', 'Make', 'Model', 'Submodel'];
  var sortedSignatures = new WeakMap();
  var scheduled = false;
  var garageNavigationScheduled = false;
  var filterChromeScheduled = false;
  var pendingGarageDialogSelection = null;
  var filterRootSelector = [
    '.parity-category-tree',
    '#cm_results',
    '#cm-collection-page',
    '#cm-collection-list',
    '#cm-brand-list',
    '#cm_FacetDialog',
    '.FacetDialog',
  ].join(', ');

  function encodeVehicleSegment(value) {
    return encodeURIComponent(String(value || '').trim());
  }

  function clean(value) {
    return String(value || '')
      .replace(/&amp;/gi, '&')
      .replace(/\u00a0/g, ' ')
      .replace(/[^a-z0-9]+/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function optionText(option) {
    return (option.textContent || option.label || '').replace(/\s+/g, ' ').trim();
  }

  function priorityRank(option) {
    var normalized = clean(optionText(option));

    for (var index = 0; index < priorityMakes.length; index += 1) {
      if (priorityMakes[index].some(function (make) {
        return normalized === make || normalized.indexOf(make + ' ') === 0;
      })) {
        return index;
      }
    }

    return priorityMakes.length;
  }

  function isPlaceholder(option) {
    if (!option) return false;
    var text = clean(optionText(option));
    return option.value === '' || text === '' || text === 'make' || text === 'select make' || text === 'choose make';
  }

  function optionSignature(select) {
    return Array.from(select.options)
      .map(function (option) {
        return [
          option.value,
          optionText(option),
          option.disabled ? '1' : '0',
          option.hidden ? '1' : '0',
        ].join('\u0000');
      })
      .join('\u0001');
  }

  function isMakeSelect(select) {
    if (!select || select.tagName !== 'SELECT') return false;
    if (select.matches('[data-parity-fitment-proxy="make"]')) return true;

    var labels = [
      select.getAttribute('aria-label'),
      select.getAttribute('name'),
      select.getAttribute('id'),
      select.getAttribute('data-placeholder'),
      select.className,
    ].join(' ');
    var hasMakeLabel = /\bmake\b/i.test(labels)
      || Array.from(select.options).some(function (option) {
        return clean(optionText(option)) === 'make';
      });

    if (!hasMakeLabel) return false;

    return Boolean(select.closest([
      '.cm_vehicle-widget',
      '.cm_vehicle-widget__verify-fitment',
      '.cm_ymm',
      '[class*="cm_"]',
      '[id^="cm-"]',
      '#cm-ymm',
      '#cm-garage',
      '#cm-mobile-garage',
      '[data-parity-fitment-selector]',
    ].join(',')));
  }

  function compareOptions(left, right) {
    var leftRank = priorityRank(left.option);
    var rightRank = priorityRank(right.option);

    if (leftRank !== rightRank) return leftRank - rightRank;

    var textCompare = optionText(left.option).localeCompare(optionText(right.option), undefined, {
      numeric: true,
      sensitivity: 'base',
    });

    return textCompare || left.index - right.index;
  }

  function sortSelect(select) {
    if (!isMakeSelect(select) || select.options.length < 2) return false;

    var currentSignature = optionSignature(select);
    if (sortedSignatures.get(select) === currentSignature) return false;

    var options = Array.from(select.options);
    var placeholders = [];
    var realOptions = [];

    options.forEach(function (option, index) {
      if (isPlaceholder(option) && realOptions.length === 0) {
        placeholders.push({ option: option, index: index });
      } else {
        realOptions.push({ option: option, index: index });
      }
    });

    var sorted = placeholders.concat(realOptions.sort(compareOptions));
    var unchanged = sorted.every(function (entry, index) {
      return entry.option === options[index];
    });

    if (unchanged) {
      sortedSignatures.set(select, currentSignature);
      return false;
    }

    var selectedValue = select.value;
    var selectedOptions = options.filter(function (option) { return option.selected; });
    var fragment = document.createDocumentFragment();

    sorted.forEach(function (entry) {
      fragment.appendChild(entry.option);
    });

    select.appendChild(fragment);

    selectedOptions.forEach(function (option) {
      option.selected = true;
    });

    if (select.value !== selectedValue && options.some(function (option) { return option.value === selectedValue; })) {
      select.value = selectedValue;
    }

    sortedSignatures.set(select, optionSignature(select));
    return true;
  }

  function collectSelects(root) {
    var selects = [];

    if (root && root.nodeType === 1 && root.matches && root.matches('select')) {
      selects.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll('select').forEach(function (select) {
        selects.push(select);
      });
    }

    return selects;
  }

  function sortAll(root) {
    collectSelects(root || document).forEach(sortSelect);
  }

  function getCategoryFacetSource() {
    return Array.from(document.querySelectorAll('[data-parity-category-filter-source]')).find(function (node) {
      return !node.closest('#cm_FacetDialog');
    }) || null;
  }

  function setCategoryFacetExpanded(facet, expanded) {
    var toggle = facet?.querySelector?.('[data-parity-category-filter-toggle]');
    var body = facet?.querySelector?.('[data-parity-category-filter-body]');
    if (!toggle || !body) return;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    body.hidden = !expanded;
  }

  function bindCategoryFacet(facet) {
    if (!facet || facet.dataset.parityCategoryFilterBound === 'true') return;

    var toggle = facet.querySelector('[data-parity-category-filter-toggle]');
    if (!toggle) return;

    facet.dataset.parityCategoryFilterBound = 'true';
    setCategoryFacetExpanded(facet, toggle.getAttribute('aria-expanded') !== 'false');

    var handleToggle = function (event) {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target?.closest?.('.parity-cm-category-facet__shop-all')) return;

      event.preventDefault();
      setCategoryFacetExpanded(facet, toggle.getAttribute('aria-expanded') !== 'true');
    };

    toggle.addEventListener('click', handleToggle);
    toggle.addEventListener('keydown', handleToggle);
  }

  function insertCategoryFacet(target, facet) {
    if (!target || !facet) return;

    if (facet.parentElement !== target || target.firstElementChild !== facet) {
      target.insertBefore(facet, target.firstElementChild);
    }

    bindCategoryFacet(facet);
  }

  function syncCategoryFacetDialogClone(source) {
    document.querySelectorAll('#cm_FacetDialog .cmRepeater_facets').forEach(function (target) {
      var existing = Array.from(target.children).find(function (child) {
        return child.matches?.('[data-parity-category-filter-source], [data-parity-category-filter-clone]');
      });
      var created = false;

      if (!existing) {
        existing = source.cloneNode(true);
        created = true;
      }

      existing.removeAttribute('data-parity-category-filter-source');
      existing.dataset.parityCategoryFilterClone = 'true';
      if (created) existing.dataset.parityCategoryFilterBound = 'false';
      insertCategoryFacet(target, existing);

      Array.from(target.querySelectorAll('[data-parity-category-filter-clone]')).forEach(function (candidate) {
        if (candidate !== existing) candidate.remove();
      });
    });
  }

  function syncCategoryFacets() {
    var source = getCategoryFacetSource();
    if (!source) return;

    var target = document.querySelector([
      '#cm_results .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
      '#cm-collection-page .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
      '#cm-collection-list .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
      '#cm-brand-list .cm_FacetPanel:not(.dialog-body) .cmRepeater_facets',
    ].join(','));

    if (target) {
      insertCategoryFacet(target, source);
    } else {
      bindCategoryFacet(source);
    }

    syncCategoryFacetDialogClone(source);
  }

  function closestFilterRoot(node) {
    return node?.closest?.(filterRootSelector) || null;
  }

  function getFacetTitle(facet) {
    if (!facet) return null;

    return Array.from(facet.children).find(function (child) {
      return child.matches?.('.facettitle, [data-parity-category-filter-toggle]');
    }) || null;
  }

  function getFacetBody(facet, title) {
    if (!facet) return null;

    var body = facet.querySelector('[data-parity-category-filter-body]');
    if (body) return body;

    body = Array.from(facet.children).find(function (child) {
      return child !== title && child.matches?.('.facetbody');
    });
    if (body) return body;

    return Array.from(facet.children).find(function (child) {
      return child !== title;
    }) || null;
  }

  function isFacetBodyCollapsed(body) {
    if (!body) return true;
    if (body.hidden || body.classList.contains('collapsed')) return true;
    if (/^0(?:px)?$/i.test(String(body.style.height || '').trim())) return true;

    var style = window.getComputedStyle?.(body);
    return style?.display === 'none';
  }

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function setClassIfChanged(element, className, enabled) {
    if (element.classList.contains(className) !== enabled) {
      element.classList.toggle(className, enabled);
    }
  }

  function setHiddenIfChanged(element, hidden) {
    if (element.hidden !== hidden) element.hidden = hidden;
  }

  function setInlineStyleIfChanged(element, property, value) {
    if (element.style[property] !== value) element.style[property] = value;
  }

  function removeInlineStyleIfPresent(element, property) {
    if (element.style.getPropertyValue(property)) element.style.removeProperty(property);
  }

  function setFilterFacetExpanded(facet, expanded) {
    var title = getFacetTitle(facet);
    var body = getFacetBody(facet, title);
    if (!title || !body) return;

    setAttributeIfChanged(title, 'aria-expanded', expanded ? 'true' : 'false');
    setClassIfChanged(facet, 'parity-cm-facet-expanded', expanded);
    setClassIfChanged(facet, 'parity-cm-facet-collapsed', !expanded);
    setHiddenIfChanged(body, !expanded);
    setClassIfChanged(body, 'collapsed', !expanded);
    setInlineStyleIfChanged(body, 'transition', 'none');
    setInlineStyleIfChanged(body, 'animation', 'none');

    if (expanded) {
      removeInlineStyleIfPresent(body, 'display');
      removeInlineStyleIfPresent(body, 'height');
      removeInlineStyleIfPresent(body, 'overflow');
      removeInlineStyleIfPresent(body, 'position');
    } else {
      setInlineStyleIfChanged(body, 'height', '0px');
      setInlineStyleIfChanged(body, 'overflow', 'hidden');
      setInlineStyleIfChanged(body, 'position', 'relative');
      removeInlineStyleIfPresent(body, 'display');
    }
  }

  function normalizeFilterFacet(facet) {
    var title = getFacetTitle(facet);
    var body = getFacetBody(facet, title);
    if (!title || !body || !closestFilterRoot(facet)) return;

    facet.dataset.parityCmFacet = 'true';
    title.dataset.parityCmFacetToggle = 'true';
    body.dataset.parityCmFacetBody = 'true';

    if (!/^(button|a)$/i.test(title.tagName) && !title.hasAttribute('role')) {
      title.setAttribute('role', 'button');
    }

    if (!title.hasAttribute('tabindex')) {
      title.tabIndex = 0;
    }

    var ariaExpanded = title.getAttribute('aria-expanded');
    var expanded = ariaExpanded === 'true' || (ariaExpanded !== 'false' && !isFacetBodyCollapsed(body));
    setFilterFacetExpanded(facet, expanded);
  }

  function activeFilterChipCount(chips) {
    return chips?.querySelectorAll?.('.cmTemplate_chip')?.length || 0;
  }

  function isActiveFilterChipSource(chips) {
    if (!chips || !activeFilterChipCount(chips)) return false;
    if (chips.closest('#cm_FacetDialog, .FacetDialog')) return false;
    if (chips.closest('#cm-garage, #cm-mobile-garage, .cm_garageDropdown')) return false;

    return true;
  }

  function findDesktopActiveFilterChips(root) {
    if (!root) return null;

    var preferred = root.querySelector('.cm_FacetPanel > .cm_FilterChips, .cm_FacetPanel > .cm_filterChips');
    if (isActiveFilterChipSource(preferred)) return preferred;

    var raw = Array.from(root.querySelectorAll('.cm_FilterChips, .cm_filterChips')).find(function (chips) {
      return isActiveFilterChipSource(chips) && !chips.closest('.parity-cm-active-filters');
    });
    if (raw) return raw;

    var hosted = root.querySelector(':scope > .parity-cm-active-filters--desktop > .cm_FilterChips, :scope > .parity-cm-active-filters--desktop > .cm_filterChips');
    return isActiveFilterChipSource(hosted) ? hosted : null;
  }

  function activeFilterCountForRoot(root) {
    if (!root) return 0;

    var count = 0;
    var candidates = [
      root.querySelector(':scope > .parity-cm-active-filters--desktop > .cm_FilterChips, :scope > .parity-cm-active-filters--desktop > .cm_filterChips'),
      root.querySelector('.cm_FacetPanel > .cm_FilterChips, .cm_FacetPanel > .cm_filterChips'),
    ];

    root.querySelectorAll?.('.cm_FilterChips, .cm_filterChips').forEach(function (chips) {
      if (!chips.closest('#cm_FacetDialog, .FacetDialog')) candidates.push(chips);
    });

    candidates.forEach(function (chips) {
      count = Math.max(count, activeFilterChipCount(chips));
    });

    return count;
  }

  function syncFilterDialogButtonLabels(root) {
    var scope = root || document;
    var roots = new Set();

    if (scope.matches?.('#cm_results, #cm-collection-page, #cm-collection-list, #cm-brand-list')) roots.add(scope);
    scope.querySelectorAll?.('#cm_results, #cm-collection-page, #cm-collection-list, #cm-brand-list').forEach(function (node) {
      roots.add(node);
    });

    roots.forEach(function (root) {
      var count = activeFilterCountForRoot(root);
      var label = count > 0 ? 'Filters (' + count + ')' : 'Filters';

      root.querySelectorAll('.cm_SearchHeader .cm_facetDialogButton').forEach(function (holder) {
        var button = holder.querySelector('.cm_dialogButton') || holder;
        button.querySelectorAll('.cm_icon, svg').forEach(function (icon) {
          icon.remove();
        });
        button.textContent = label;
        button.setAttribute('aria-label', label);
        button.dataset.parityCmFilterCount = String(count);
        holder.dataset.parityCmFilterCount = String(count);
      });
    });
  }

  function prepareActiveFilterChips(chips) {
    if (!chips) return;

    chips.classList.add('parity-cm-active-filter-chips');

    chips.querySelectorAll('.facetholder').forEach(function (facet) {
      facet.classList.add('parity-cm-active-filter-facet');
    });

    chips.querySelectorAll('.facettitle').forEach(function (title) {
      title.setAttribute('aria-hidden', 'true');
      title.tabIndex = -1;
    });

    chips.querySelectorAll('.facetbody').forEach(function (body) {
      body.hidden = false;
      body.classList.remove('collapsed');
      body.style.removeProperty('height');
      body.style.removeProperty('overflow');
      body.style.removeProperty('position');
      body.style.transition = 'none';
      body.style.animation = 'none';
    });

    chips.querySelectorAll('.cmTemplate_chip').forEach(function (chip) {
      chip.dataset.parityCmActiveFilterChip = 'true';
    });

    chips.querySelectorAll('.cm_filter-chips_button, [data-cm-role="start-over"]').forEach(function (button) {
      button.textContent = 'Clear All';
      button.classList.add('cm_filter-chips_button');
    });
  }

  function ensureActiveFilterHost(parent, className, anchor, insertAfter) {
    if (!parent) return null;

    var host = parent.querySelector(':scope > .' + className);
    if (!host) {
      host = document.createElement('div');
      host.className = 'parity-cm-active-filters ' + className;
    }

    if (anchor) {
      if (insertAfter) {
        anchor.insertAdjacentElement('afterend', host);
      } else {
        parent.insertBefore(host, anchor);
      }
    } else if (host.parentElement !== parent) {
      parent.appendChild(host);
    }

    return host;
  }

  function moveActiveFilterChips(host, chips) {
    if (!host || !chips) return;

    Array.from(host.children).forEach(function (child) {
      if (child !== chips) child.remove();
    });

    prepareActiveFilterChips(chips);
    if (chips.parentElement !== host) host.appendChild(chips);
  }

  function syncDesktopActiveFilterChips(root) {
    if (!root || root.closest?.('#cm_FacetDialog, .FacetDialog')) return;

    var searchHeader = root.querySelector('.cm_SearchHeader');
    var source = findDesktopActiveFilterChips(root);
    var host = root.querySelector(':scope > .parity-cm-active-filters--desktop');

    if (!source || !activeFilterChipCount(source) || !searchHeader) {
      if (host) host.remove();
      return;
    }

    host = ensureActiveFilterHost(root, 'parity-cm-active-filters--desktop', searchHeader, true);
    moveActiveFilterChips(host, source);
  }

  function syncMobileActiveFilterChips(dialog) {
    if (!dialog || !dialog.matches?.('#cm_FacetDialog, .FacetDialog')) return;

    var header = dialog.querySelector('.dialog-header');
    var buttons = header?.querySelector?.('.buttons-container');
    var source = dialog.querySelector('.dialog-body > .cm_filterChips, .dialog-body > .cm_FilterChips, .cm_FacetPanel > .cm_filterChips, .cm_FacetPanel > .cm_FilterChips')
      || header?.querySelector?.(':scope > .parity-cm-active-filters--mobile > .cm_filterChips, :scope > .parity-cm-active-filters--mobile > .cm_FilterChips');
    var host = header?.querySelector?.(':scope > .parity-cm-active-filters--mobile');

    if (!source || !activeFilterChipCount(source) || !header) {
      if (host) host.remove();
      return;
    }

    host = ensureActiveFilterHost(header, 'parity-cm-active-filters--mobile', buttons, false);
    moveActiveFilterChips(host, source);
  }

  function syncActiveFilterChips(root) {
    var scope = root || document;
    var roots = new Set();
    var dialogs = new Set();

    if (scope.matches?.('#cm_results, #cm-collection-page, #cm-collection-list, #cm-brand-list')) roots.add(scope);
    if (scope.matches?.('#cm_FacetDialog, .FacetDialog')) dialogs.add(scope);

    scope.querySelectorAll?.('#cm_results, #cm-collection-page, #cm-collection-list, #cm-brand-list').forEach(function (node) {
      roots.add(node);
    });
    scope.querySelectorAll?.('#cm_FacetDialog, .FacetDialog').forEach(function (node) {
      dialogs.add(node);
    });

    roots.forEach(syncDesktopActiveFilterChips);
    dialogs.forEach(syncMobileActiveFilterChips);
  }

  function normalizeFilterFacets(root) {
    var scope = root || document;
    var facets = [];

    if (scope.matches?.('.facetholder')) facets.push(scope);
    scope.querySelectorAll?.('.facetholder').forEach(function (facet) {
      facets.push(facet);
    });

    facets.forEach(normalizeFilterFacet);
  }

  function isFilterDialogClosed(dialog) {
    if (!dialog || !dialog.isConnected) return true;
    if (dialog.hidden || dialog.getAttribute('aria-hidden') === 'true') return true;
    if (dialog.classList.contains('hidden') || dialog.classList.contains('is-hidden')) return true;
    if (/^none$/i.test(String(dialog.style?.display || '').trim())) return true;

    return false;
  }

  function releaseFilterDialogOverlay(dialog) {
    if (!dialog) return;
    dialog.classList.remove('parity-cm-filter-dialog');
  }

  function forceFilterDialogClosed(dialog) {
    if (!dialog || !dialog.isConnected) return;
    dialog.dataset.parityCmForcedClosed = 'true';
    dialog.style.display = 'none';
    dialog.setAttribute('aria-hidden', 'true');
    releaseFilterDialogOverlay(dialog);
  }

  function releaseClosedFilterDialogOverlay(dialog) {
    if (isFilterDialogClosed(dialog)) releaseFilterDialogOverlay(dialog);
  }

  function scheduleFilterDialogRelease(dialog, force) {
    window.setTimeout(function () {
      if (force && isFilterDialogClosed(dialog)) dialog.dataset.parityCmForcedClosed = 'true';
      releaseClosedFilterDialogOverlay(dialog);
    }, 0);
    window.setTimeout(function () {
      if (isFilterDialogClosed(dialog)) {
        if (force) dialog.dataset.parityCmForcedClosed = 'true';
        releaseFilterDialogOverlay(dialog);
      } else if (force) {
        forceFilterDialogClosed(dialog);
      }
    }, 120);
  }

  function requestFilterDialogClose(dialog) {
    if (!dialog) return;

    var doneButton = dialog.querySelector('.cm_facet-dialog_button-done');
    if (doneButton) {
      dialog.dataset.parityCmForcedClosed = 'true';
      doneButton.click();
    } else {
      forceFilterDialogClosed(dialog);
    }

    scheduleFilterDialogRelease(dialog, true);
  }

  function normalizeFilterDialog(dialog) {
    if (!dialog || !dialog.matches?.('#cm_FacetDialog, .FacetDialog')) return;
    if (!dialog.querySelector('.dialog-container')) return;

    if (isFilterDialogClosed(dialog)) {
      releaseFilterDialogOverlay(dialog);
      return;
    }

    dialog.classList.add('parity-cm-filter-dialog');

    var title = dialog.querySelector('.dialog-title');
    if (title) title.textContent = 'Filter';

    var clear = dialog.querySelector('.cm_facet-dialog_button-clear span, .cm_facet-dialog_button-clear');
    if (clear) clear.textContent = 'Clear All';

    var done = dialog.querySelector('.cm_facet-dialog_button-done span, .cm_facet-dialog_button-done');
    if (done) done.textContent = 'Apply';

    var doneButton = dialog.querySelector('.cm_facet-dialog_button-done');
    if (doneButton && !doneButton.dataset.parityCmFilterCloseBound) {
      doneButton.dataset.parityCmFilterCloseBound = 'true';
      doneButton.addEventListener('click', function () {
        dialog.dataset.parityCmForcedClosed = 'true';
        scheduleFilterDialogRelease(dialog, true);
      });
    }

    if (!dialog.dataset.parityCmBackdropCloseBound) {
      dialog.dataset.parityCmBackdropCloseBound = 'true';
      dialog.addEventListener('click', function (event) {
        if (event.target?.closest?.('.dialog-content')) return;
        if (!dialog.classList.contains('parity-cm-filter-dialog')) return;

        event.preventDefault();
        requestFilterDialogClose(dialog);
      });
    }

    var header = dialog.querySelector('.dialog-header');
    if (!header || header.querySelector('.parity-cm-filter-close')) return;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'parity-cm-filter-close';
    close.setAttribute('aria-label', 'Close filters');
    close.addEventListener('click', function (event) {
      event.preventDefault();
      requestFilterDialogClose(dialog);
    });
    header.appendChild(close);
  }

  function normalizeFilterChrome(root) {
    syncActiveFilterChips(root || document);
    syncFilterDialogButtonLabels(root || document);
    normalizeFilterFacets(root || document);

    var scope = root || document;
    if (scope.matches?.('#cm_FacetDialog, .FacetDialog')) normalizeFilterDialog(scope);
    scope.querySelectorAll?.('#cm_FacetDialog, .FacetDialog').forEach(normalizeFilterDialog);
  }

  function handleFilterFacetToggle(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (event.target?.closest?.('.parity-cm-category-facet__shop-all')) return;

    var title = event.target?.closest?.('[data-parity-cm-facet-toggle], .facettitle, [data-parity-category-filter-toggle]');
    var facet = title?.closest?.('.facetholder');
    if (!title || !facet || !closestFilterRoot(facet)) return;

    var body = getFacetBody(facet, title);
    if (!body) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setFilterFacetExpanded(facet, title.getAttribute('aria-expanded') !== 'true');
  }

  function reopenForcedFilterDialog(dialog) {
    if (!dialog || dialog.dataset.parityCmForcedClosed !== 'true') return false;

    delete dialog.dataset.parityCmForcedClosed;
    dialog.hidden = false;
    dialog.classList.remove('hidden', 'is-hidden');
    dialog.style.removeProperty('display');
    dialog.removeAttribute('aria-hidden');
    normalizeFilterDialog(dialog);
    return true;
  }

  function reopenForcedFilterDialogs(root) {
    var scope = root || document;
    var reopened = false;

    scope.querySelectorAll?.('#cm_FacetDialog, .FacetDialog').forEach(function (dialog) {
      reopened = reopenForcedFilterDialog(dialog) || reopened;
    });

    return reopened;
  }

  function handleFilterDialogOpen(event) {
    if (!event.target?.closest?.('.cm_SearchHeader .cm_facetDialogButton, .cm_SearchHeader .cm_dialogButton')) return;

    window.setTimeout(function () {
      if (reopenForcedFilterDialogs(document)) normalizeFilterChrome(document);
    }, 0);
    window.setTimeout(function () {
      if (reopenForcedFilterDialogs(document)) normalizeFilterChrome(document);
    }, 120);
  }

  function activeFilterChipFromEvent(event) {
    var chip = event.target?.closest?.('.cmTemplate_chip');
    if (!chip) return null;
    if (chip.closest('.parity-cm-active-filters')) return chip;

    var chips = chip.closest('.cm_FilterChips, .cm_filterChips');
    if (!chips) return null;
    if (chips.closest('#cm-garage, #cm-mobile-garage, .cm_garageDropdown')) return null;

    return chip;
  }

  function handleActiveFilterChipClick(event) {
    var chip = activeFilterChipFromEvent(event);
    if (!chip || event.target?.closest?.('.facetentryval')) return;

    var remove = chip.querySelector('.facetentryval');
    if (!remove) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    remove.click();
  }

  function handleActiveFilterChipKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var chip = activeFilterChipFromEvent(event);
    if (!chip || event.target?.closest?.('.facetentryval')) return;

    var remove = chip.querySelector('.facetentryval');
    if (!remove) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    remove.click();
  }

  function setupFilterChrome() {
    normalizeFilterChrome(document);

    if (filterChromeScheduled) return;
    filterChromeScheduled = true;

    document.addEventListener('click', handleFilterFacetToggle, true);
    document.addEventListener('click', handleFilterDialogOpen, true);
    document.addEventListener('click', handleActiveFilterChipClick, true);
    document.addEventListener('keydown', handleFilterFacetToggle, true);
    document.addEventListener('keydown', handleActiveFilterChipKeydown, true);
  }

  function isVehicleDialogWidget(node) {
    return Boolean(node?.closest?.('.cm_vehicle-widget__dialog, #cm_VehicleWidgetDialog, .VehicleWidgetDialog, .vehicle-dialog'));
  }

  function getVehicleWidget(node) {
    return node?.closest?.('.cm_vehicle-widget') || null;
  }

  function isVerifyFitmentWidget(widget) {
    return Boolean(widget?.classList?.contains('cm_vehicle-widget__verify-fitment'));
  }

  function vehicleSearchUrl(vehicle) {
    var parts = ['Year', 'Make', 'Model', 'Submodel']
      .filter(function (field) { return vehicle[field]; })
      .map(function (field) { return field + '/' + encodeVehicleSegment(vehicle[field]); });

    if (parts.length) return '/pages/search?' + parts.join('/');

    if (window.Convermax?.getVehicleSearchParams) {
      var params = window.Convermax.getVehicleSearchParams();
      if (params) return '/pages/search?' + params;
    }

    return '/pages/search';
  }

  function vehicleLabel(vehicle) {
    return ['Year', 'Make', 'Model', 'Submodel']
      .map(function (field) { return String(vehicle?.[field] || '').trim(); })
      .filter(Boolean)
      .join(' ');
  }

  function vehicleFromWidget(widget) {
    if (!widget) return null;

    var vehicle = {};

    widget.querySelectorAll('select[aria-label]').forEach(function (select) {
      var field = select.getAttribute('aria-label');
      if (vehicleFields.indexOf(field) === -1 || !select.value) return;
      vehicle[field] = select.value;
    });

    if (!vehicle.Year || !vehicle.Make || !vehicle.Model) return null;
    if (!Object.prototype.hasOwnProperty.call(vehicle, 'Submodel')) vehicle.Submodel = '';

    return vehicle;
  }

  function selectedVariantId() {
    var selectedVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (selectedVariant?.value) return selectedVariant.value;

    var product = window.meta?.product || window.ShopifyAnalytics?.meta?.product;
    return product?.variants?.[0]?.id || null;
  }

  function selectedProductId() {
    var product = window.meta?.product || window.ShopifyAnalytics?.meta?.product;
    if (product?.id) return product.id;

    var productForm = document.querySelector('form[id^="product_form_"]');
    var match = productForm?.id?.match(/^product_form_(\d+)/);
    return match?.[1] || null;
  }

  function refreshVerifyFitmentWidget() {
    if (!document.querySelector('.cm_vehicle-widget__verify-fitment')) return;
    if (!window.Convermax?.updateVerifyFitmentWidget) return;

    var productId = selectedProductId();
    var variantId = selectedVariantId();
    if (!productId) return;

    window.setTimeout(function () {
      window.Convermax.updateVerifyFitmentWidget(productId, variantId);
    }, 50);
    window.setTimeout(function () {
      window.Convermax.updateVerifyFitmentWidget(productId, selectedVariantId() || variantId);
    }, 650);
  }

  function dispatchVehicleSelected(vehicle, searchUrl) {
    var detail = { vehicle: vehicle, searchUrl: searchUrl };
    document.dispatchEvent(new CustomEvent('garage:vehicle-updated', { bubbles: true, detail: detail }));
    window.dispatchEvent(new CustomEvent('parity:garage-vehicle-selected', { detail: detail }));
  }

  function compactVehicle(vehicle) {
    var compact = {
      Year: vehicle.Year,
      Make: vehicle.Make,
      Model: vehicle.Model,
      Submodel: vehicle.Submodel || '',
    };

    return compact;
  }

  function vehicleKey(vehicle) {
    return ['Year', 'Make', 'Model', 'Submodel']
      .map(function (field) { return String(vehicle?.[field] || ''); })
      .join('\u0000');
  }

  function looseVehicleKey(vehicle) {
    return ['Year', 'Make', 'Model', 'Submodel']
      .map(function (field) { return clean(vehicle?.[field]); })
      .join('\u0000');
  }

  function selectedVehicleList(vehicle) {
    var selected = compactVehicle(vehicle);
    var seen = new Set();
    var list = [];

    function pushUnique(item) {
      var compact = compactVehicle(item);
      var looseKey = looseVehicleKey(compact);
      var strictKey = vehicleKey(compact);

      if (seen.has(looseKey) || seen.has(strictKey)) return;

      seen.add(looseKey);
      seen.add(strictKey);
      list.push(compact);
    }

    try {
      (window.Convermax?.getVehicleList?.() || []).forEach(function (item) {
        pushUnique(item);
      });
    } catch (_error) {
      // Convermax can be mid-render while the dialog is closing; keep the selected vehicle below.
    }

    pushUnique(selected);
    return list;
  }

  function recentGarageVehicle() {
    if (!window.Convermax?.getVehicleList) return null;

    try {
      var list = window.Convermax.getVehicleList() || [];
      for (var index = list.length - 1; index >= 0; index -= 1) {
        var vehicle = list[index];
        if (vehicle?.Year && vehicle?.Make && vehicle?.Model) return compactVehicle(vehicle);
      }
    } catch (_error) {
      return null;
    }

    return null;
  }

  function garageVehicleList() {
    if (!window.Convermax?.getVehicleList) return [];

    try {
      var seen = new Set();
      var list = [];

      (window.Convermax.getVehicleList() || []).forEach(function (item) {
        if (!item?.Year || !item?.Make || !item?.Model) return;

        var vehicle = compactVehicle(item);
        var key = looseVehicleKey(vehicle);
        if (seen.has(key)) return;

        seen.add(key);
        list.push(vehicle);
      });

      return list;
    } catch (_error) {
      return [];
    }
  }

  function selectedGarageVehicle() {
    if (!window.Convermax?.getVehicle) return null;

    try {
      var vehicle = window.Convermax.getVehicle() || {};
      if (vehicle?.Year && vehicle?.Make && vehicle?.Model) return compactVehicle(vehicle);
    } catch (_error) {
      return null;
    }

    return null;
  }

  function garageVehicleFromNode(node) {
    if (!node || !window.Convermax?.getVehicleList) return null;

    var nodeLabel = clean(node.textContent || '');
    if (!nodeLabel) return null;

    try {
      var list = window.Convermax.getVehicleList() || [];
      for (var index = 0; index < list.length; index += 1) {
        var vehicle = compactVehicle(list[index]);
        var label = clean(vehicleLabel(vehicle));
        if (label && (nodeLabel === label || nodeLabel.indexOf(label) !== -1 || label.indexOf(nodeLabel) !== -1)) {
          return vehicle;
        }
      }
    } catch (_error) {
      return null;
    }

    return null;
  }

  function dedupeGarageVehicleList(vehicle) {
    if (!window.Convermax?.setVehicleList || !window.Convermax?.getVehicleList) return;

    var current = window.Convermax.getVehicleList();
    var deduped = selectedVehicleList(vehicle);
    if (current.length === deduped.length) return;

    if (window.Convermax.removeVehicle) {
      try {
        window.Convermax.removeVehicle(compactVehicle(vehicle));
        return;
      } catch (_error) {
        // Fall back to replacing the list below.
      }
    }

    window.Convermax.setVehicleList(deduped);
    refreshVerifyFitmentWidget();
  }

  function saveVehicle(vehicle) {
    if (!vehicle || !window.Convermax) return null;

    try {
      window.Convermax.setVehicle?.(vehicle);
    } catch (error) {
      if (!Object.prototype.hasOwnProperty.call(vehicle, 'Submodel')) throw error;
      var minimalVehicle = {
        Year: vehicle.Year,
        Make: vehicle.Make,
        Model: vehicle.Model,
      };
      window.Convermax.setVehicle?.(minimalVehicle);
    }

    var searchUrl = vehicleSearchUrl(vehicle);
    refreshVerifyFitmentWidget();
    dispatchVehicleSelected(vehicle, searchUrl);
    pendingGarageDialogSelection = null;
    window.setTimeout(function () {
      dedupeGarageVehicleList(vehicle);
    }, 1200);
    window.setTimeout(function () {
      renderRecentGarageVehicleActions(document);
    }, 0);
    return searchUrl;
  }

  function isGarageWidget(widget) {
    return Boolean(widget?.closest?.('#cm-garage, #cm-mobile-garage, .cm_garageDropdown'));
  }

  function inlineVehicleWidgets(root) {
    return Array.from((root || document).querySelectorAll?.('.cm_vehicle-widget') || [])
      .filter(function (widget) {
        if (isVehicleDialogWidget(widget) || isVerifyFitmentWidget(widget) || isGarageWidget(widget)) return false;
        return Boolean(widget.querySelector('.cm_vehicle-widget_title'));
      });
  }

  function hideNativeRecentVehicle(widget, action) {
    widget.querySelectorAll('[data-parity-native-recent-vehicle-hidden="true"]').forEach(function (node) {
      node.hidden = false;
      node.removeAttribute('data-parity-native-recent-vehicle-hidden');
    });

    Array.from(widget.querySelectorAll('*')).forEach(function (node) {
      if (action && (node === action || node.contains(action) || action.contains(node))) return;
      if (node.matches('select, option')) return;

      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/\bRecent Vehicle\b/i.test(text)) return;

      var childHasRecent = Array.from(node.children).some(function (child) {
        return /\bRecent Vehicle\b/i.test((child.textContent || '').replace(/\s+/g, ' ').trim());
      });
      if (childHasRecent) return;

      var container = node;
      while (container.parentElement && container.parentElement !== widget) {
        var parent = container.parentElement;
        if (parent.contains(action) || parent.querySelector('select, .cm_vehicle-widget_title')) break;
        if ((parent.textContent || '').replace(/\s+/g, ' ').trim().length > 180) break;
        container = parent;
      }

      container.hidden = true;
      container.dataset.parityNativeRecentVehicleHidden = 'true';
    });
  }

  function ensureInlineVehicleHeading(widget, title) {
    var existing = Array.from(widget.querySelectorAll('.parity-cm-vehicle-widget__heading')).find(function (node) {
      return node.contains(title);
    });
    if (existing) return existing;

    var parent = title?.parentElement || widget;
    var body = Array.from(parent.children).find(function (child) {
      return child !== title && (child.matches?.('.cm_vehicle-widget_body') || child.querySelector?.('select, .cm_vehicle-widget_button__go'));
    });

    if (!body) {
      parent.classList.add('parity-cm-vehicle-widget__heading');
      return parent;
    }

    var heading = document.createElement('div');
    heading.className = 'parity-cm-vehicle-widget__heading';
    parent.insertBefore(heading, title);

    while (heading.nextSibling && heading.nextSibling !== body) {
      heading.appendChild(heading.nextSibling);
    }

    return heading;
  }

  function ensureInlineGarageActions(header) {
    var actions = header.querySelector(':scope > .parity-inline-garage-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'parity-inline-garage-actions';
      header.appendChild(actions);
    }
    return actions;
  }

  function ensureSavedGarageVehicleAction(actions) {
    var action = actions.querySelector('[data-parity-saved-garage-vehicle="true"]');
    if (!action) {
      action = document.createElement('div');
      action.className = 'parity-saved-garage-vehicle';
      action.dataset.paritySavedGarageVehicle = 'true';
      action.innerHTML = '<span class="parity-saved-garage-vehicle__label">Garage</span><button class="parity-saved-garage-vehicle__button" type="button" data-parity-saved-garage-vehicle-open>Select a Saved Vehicle</button>';
      actions.appendChild(action);
    }
    return action;
  }

  function removeInlineSavedGaragePopovers(root) {
    (root || document).querySelectorAll?.('.parity-saved-garage-popover').forEach(function (popover) {
      popover.remove();
    });
    (root || document).querySelectorAll?.('[data-parity-saved-garage-vehicle-open][aria-expanded="true"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function renderInlineSavedGaragePopover(action) {
    if (!action) return null;

    var existing = action.querySelector('.parity-saved-garage-popover');
    if (existing) {
      existing.remove();
      action.querySelector('[data-parity-saved-garage-vehicle-open]')?.setAttribute('aria-expanded', 'false');
      return null;
    }

    removeInlineSavedGaragePopovers(document);

    var vehicles = garageVehicleList();
    var popover = document.createElement('div');
    popover.className = 'parity-saved-garage-popover';
    popover.dataset.paritySavedGaragePopoverOpen = 'true';
    popover.setAttribute('role', 'dialog');
    popover.setAttribute('aria-label', 'Select a saved vehicle');

    popover.innerHTML = '<div class="parity-saved-garage-popover__title">Select a Vehicle</div><div class="parity-saved-garage-popover__group-title">Saved Vehicles</div><div class="parity-saved-garage-popover__list"></div>';

    var list = popover.querySelector('.parity-saved-garage-popover__list');
    if (vehicles.length) {
      vehicles.forEach(function (vehicle, index) {
        var button = document.createElement('button');
        button.className = 'parity-saved-garage-popover__vehicle';
        button.type = 'button';
        button.dataset.paritySavedGarageVehicleIndex = String(index);
        button.textContent = vehicleLabel(vehicle);
        list.appendChild(button);
      });
    } else {
      var empty = document.createElement('div');
      empty.className = 'parity-saved-garage-popover__empty';
      empty.textContent = 'No saved vehicles';
      list.appendChild(empty);
    }

    action.appendChild(popover);
    action.querySelector('[data-parity-saved-garage-vehicle-open]')?.setAttribute('aria-expanded', 'true');
    return popover;
  }

  function ensureRecentGarageVehicleAction(actions) {
    var action = actions.querySelector('[data-parity-recent-garage-vehicle="true"]');
    if (!action) {
      action = document.createElement('div');
      action.className = 'parity-recent-garage-vehicle';
      action.dataset.parityRecentGarageVehicle = 'true';
      action.innerHTML = '<span class="parity-recent-garage-vehicle__label">Recent Vehicle</span><button class="parity-recent-garage-vehicle__button" type="button" data-parity-recent-garage-vehicle-select></button>';
      actions.appendChild(action);
    }
    return action;
  }

  function renderRecentGarageVehicleActions(root) {
    var vehicle = recentGarageVehicle();
    var selectedVehicle = selectedGarageVehicle();

    inlineVehicleWidgets(root).forEach(function (widget) {
      var recentAction = widget.querySelector('[data-parity-recent-garage-vehicle="true"]');
      var savedAction = widget.querySelector('[data-parity-saved-garage-vehicle="true"]');

      if (!vehicle) {
        widget.querySelectorAll('[data-parity-native-recent-vehicle-hidden="true"]').forEach(function (node) {
          node.hidden = false;
          node.removeAttribute('data-parity-native-recent-vehicle-hidden');
        });
        recentAction?.remove();
        savedAction?.remove();
        removeInlineSavedGaragePopovers(widget);
        widget.classList.remove('parity-cm-vehicle-widget--recent');
        widget.classList.remove('parity-cm-vehicle-widget--inline-actions');
        return;
      }

      var title = widget.querySelector('.cm_vehicle-widget_title');
      var header = ensureInlineVehicleHeading(widget, title);
      var actions = ensureInlineGarageActions(header);
      var label = vehicleLabel(vehicle);

      ensureSavedGarageVehicleAction(actions);

      if (selectedVehicle) {
        recentAction?.remove();
      } else {
        recentAction = ensureRecentGarageVehicleAction(actions);
        recentAction.querySelector('.parity-recent-garage-vehicle__button').textContent = label;
        recentAction.querySelector('.parity-recent-garage-vehicle__button').setAttribute('aria-label', 'Select recent vehicle ' + label);
      }

      widget.classList.add('parity-cm-vehicle-widget--recent');
      widget.classList.add('parity-cm-vehicle-widget--inline-actions');
      header.classList.add('parity-cm-vehicle-widget__heading');
      hideNativeRecentVehicle(widget, actions);
    });
  }

  function closeVehicleDialog() {
    var dialog = document.querySelector('#cm_VehicleWidgetDialog, .VehicleWidgetDialog.vehicle-dialog');
    var close = dialog?.querySelector?.('.close');

    if (close) {
      close.click();
      return;
    }

    if (dialog) dialog.remove();
    document.documentElement.classList.remove('cm_no-scroll');
    document.body.classList.remove('cm_no-scroll');
  }

  function navigateToVehicleSearch(vehicle, widget) {
    var searchUrl = saveVehicle(vehicle || vehicleFromWidget(widget));
    if (!searchUrl) return;
    window.location.href = searchUrl;
  }

  function applyGarageVehicleInPlace(vehicle) {
    if (!saveVehicle(vehicle)) return false;
    renderRecentGarageVehicleActions(document);
    scheduleSortAll();
    return true;
  }

  function garageDropdownRoot() {
    return document.querySelector('#cm-garage') || document.querySelector('#cm-mobile-garage') || document.querySelector('.cm_garage');
  }

  function setGarageDropdownOpen(garage, open) {
    var dropdown = garage?.querySelector?.('.cm_garageDropdown');
    if (!dropdown) return false;

    if (open) {
      dropdown.hidden = false;
      dropdown.removeAttribute('aria-hidden');
      dropdown.classList.add('parity-garage-dropdown-open');
      garage.classList.add('parity-garage-dropdown-owner-open');
      if (window.getComputedStyle?.(dropdown).display === 'none') {
        dropdown.style.display = 'block';
      }
      return true;
    }

    dropdown.classList.remove('parity-garage-dropdown-open');
    garage.classList.remove('parity-garage-dropdown-owner-open');
    if (dropdown.style.display === 'block') dropdown.style.display = 'none';
    return true;
  }

  function closeGarageDropdown(node) {
    var garage = node?.closest?.('#cm-garage, #cm-mobile-garage, .cm_garage') || garageDropdownRoot();
    setGarageDropdownOpen(garage, false);
  }

  function ensureContinueShoppingButton(widget, vehicle) {
    var go = widget?.querySelector?.('.cm_vehicle-widget_button__go');
    if (!go) return null;

    var container = go.parentElement || widget.querySelector('.cm_vehicle-widget_body') || widget;
    var button = container.querySelector('.parity-garage-continue');

    if (!button) {
      button = document.createElement('div');
      button.className = 'parity-garage-continue cm_vehicle-widget_button cm_button button-secondary';
      button.setAttribute('role', 'button');
      button.tabIndex = 0;
      go.insertAdjacentElement('afterend', button);
    }

    button.textContent = 'Continue Shopping';
    button.dataset.parityGarageContinue = 'true';
    button.onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      saveVehicle(vehicleFromWidget(widget) || vehicle);
      closeVehicleDialog();
    };
    button.onkeydown = function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      button.click();
    };

    return button;
  }

  function hideDialogClearButton(widget) {
    if (!isVehicleDialogWidget(widget)) return;

    widget.querySelectorAll('.cm_vehicle-widget_button__clear').forEach(function (button) {
      button.hidden = true;
      button.style.display = 'none';
      button.dataset.parityGarageClearHidden = 'true';
    });
  }

  function labelGarageActionButtons(root) {
    (root || document).querySelectorAll?.('.cm_vehicle-widget_button__go').forEach(function (button) {
      var widget = getVehicleWidget(button);
      if (!widget || isVerifyFitmentWidget(widget)) return;
      button.textContent = 'Shop Parts';
      button.dataset.parityGarageShopAll = 'true';
      hideDialogClearButton(widget);
    });
  }

  function renderGarageNavigationActions(widget, vehicle) {
    if (!widget || !vehicle) return;

    pendingGarageDialogSelection = {
      vehicle: compactVehicle(vehicle),
      widget: widget,
    };

    var go = widget.querySelector('.cm_vehicle-widget_button__go');
    if (go) {
      go.textContent = 'Shop Parts';
      go.dataset.parityGarageShopAll = 'true';
      go.removeAttribute('disabled');
      go.setAttribute('aria-disabled', 'false');
    }

    hideDialogClearButton(widget);
    ensureContinueShoppingButton(widget, vehicle);
  }

  function handleGarageDialogDismissClick(event) {
    if (!pendingGarageDialogSelection?.vehicle) return;

    var target = event.target;
    var dialog = document.querySelector('#cm_VehicleWidgetDialog, .VehicleWidgetDialog.vehicle-dialog');
    if (!dialog) {
      pendingGarageDialogSelection = null;
      return;
    }

    if (target?.closest?.('.cm_vehicle-widget__dialog')) return;
    if (!dialog.contains(target) && !target?.closest?.('.VehicleWidgetDialog, .vehicle-dialog')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    saveVehicle(pendingGarageDialogSelection.vehicle);
    closeVehicleDialog();
  }

  function isFinalVehicleSelect(select, widget) {
    if (!select || !widget) return false;
    if (select.getAttribute('aria-label') !== 'Model' && select.getAttribute('aria-label') !== 'Submodel') return false;

    return Array.from(widget.querySelectorAll('select[aria-label]')).every(function (item) {
      var label = item.getAttribute('aria-label');
      if (vehicleFields.indexOf(label) === -1 || item.disabled) return true;
      if (label === 'Submodel' && item.options.length <= 1) return true;
      return Boolean(item.value);
    });
  }

  function handleGarageDialogChange(event) {
    var target = event.target;
    if (!target?.matches?.('select[aria-label]')) return;

    var widget = getVehicleWidget(target);
    if (!isVehicleDialogWidget(target) || !isFinalVehicleSelect(target, widget)) return;

    var vehicle = vehicleFromWidget(widget);
    if (!vehicle) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    renderGarageNavigationActions(widget, vehicle);
  }

  function handleGarageActionClick(event) {
    var inlineSavedVehicleTarget = event.target?.closest?.('[data-parity-saved-garage-vehicle-index]');
    if (inlineSavedVehicleTarget) {
      var vehicleIndex = Number(inlineSavedVehicleTarget.getAttribute('data-parity-saved-garage-vehicle-index'));
      var inlineVehicle = garageVehicleList()[vehicleIndex];
      if (!inlineVehicle) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      applyGarageVehicleInPlace(inlineVehicle);
      removeInlineSavedGaragePopovers(document);
      return;
    }

    var savedOpenTarget = event.target?.closest?.('[data-parity-saved-garage-vehicle-open]');
    if (savedOpenTarget) {
      event.preventDefault();
      event.stopImmediatePropagation();
      renderInlineSavedGaragePopover(savedOpenTarget.closest('[data-parity-saved-garage-vehicle="true"]'));
      return;
    }

    var savedSelectTarget = event.target?.closest?.('#cm-garage .cm_garageDropdown [data-cm-role="select-vehicle"], #cm-mobile-garage .cm_garageDropdown [data-cm-role="select-vehicle"], #cm-garage .cm_garageDropdown .select-model, #cm-mobile-garage .cm_garageDropdown .select-model, .cm_garageDropdown [data-cm-role="select-vehicle"], .cm_garageDropdown .select-model');
    if (savedSelectTarget && !event.target?.closest?.('.remove-model, [data-cm-role="remove-vehicle"]')) {
      var savedVehicle = garageVehicleFromNode(savedSelectTarget);
      if (savedVehicle) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyGarageVehicleInPlace(savedVehicle);
        closeGarageDropdown(savedSelectTarget);
        return;
      }
    }

    var recentTarget = event.target?.closest?.('[data-parity-recent-garage-vehicle-select]');
    if (recentTarget) {
      var recentVehicle = recentGarageVehicle();
      if (!recentVehicle) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      applyGarageVehicleInPlace(recentVehicle);
      return;
    }

    var target = event.target?.closest?.('.cm_vehicle-widget_button__go, .parity-garage-continue');
    if (!target) return;

    var widget = getVehicleWidget(target);
    if (!widget || isVerifyFitmentWidget(widget)) return;

    var vehicle = vehicleFromWidget(widget) || window.Convermax?.getVehicle?.();
    if (!vehicle?.Year || !vehicle?.Make || !vehicle?.Model) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (target.matches('.parity-garage-continue')) {
      saveVehicle(vehicle);
      closeVehicleDialog();
      return;
    }

    navigateToVehicleSearch(vehicle, widget);
  }

  function setupGarageNavigation() {
    labelGarageActionButtons(document);
    renderRecentGarageVehicleActions(document);

    if (garageNavigationScheduled) return;
    garageNavigationScheduled = true;

    document.addEventListener('change', handleGarageDialogChange, true);
    document.addEventListener('click', handleGarageActionClick, true);
    document.addEventListener('click', handleGarageDialogDismissClick, true);
    document.addEventListener('click', function (event) {
      if (event.target?.closest?.('.parity-saved-garage-vehicle')) return;
      removeInlineSavedGaragePopovers(document);
    }, true);
  }

  function scheduleSortAll() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sortAll(document);
      labelGarageActionButtons(document);
      renderRecentGarageVehicleActions(document);
      syncCategoryFacets();
      normalizeFilterChrome(document);
    });
  }

  if ('MutationObserver' in window) {
    new MutationObserver(scheduleSortAll).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-expanded', 'aria-label', 'class', 'disabled', 'id', 'name', 'style'],
      childList: true,
      subtree: true,
    });
  }

  window.ParityConvermaxMakeOrder = {
    normalizeFilterChrome: normalizeFilterChrome,
    normalizeFilterFacets: normalizeFilterFacets,
    renderRecentGarageVehicleActions: renderRecentGarageVehicleActions,
    sortAll: sortAll,
    sortSelect: sortSelect,
  };

  sortAll(document);
  setupGarageNavigation();
  syncCategoryFacets();
  setupFilterChrome();
  document.addEventListener('DOMContentLoaded', scheduleSortAll);
  window.addEventListener('load', scheduleSortAll);
  window.setTimeout(scheduleSortAll, 250);
  window.setTimeout(scheduleSortAll, 1000);
  window.setTimeout(scheduleSortAll, 2500);
}());
